export default "__VITE_ASSET__DwvjvAuN__"